import { createRouter, createWebHistory } from "vue-router";

export const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/menu/:identifier",
    name: "Menu",
    component: () => import("../views/Menu.vue"),
  },
  {
    path: "/hub/:identifier",
    name: "Hub",
    component: () => import("../views/Hub.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: function (to, from) {
    const isInitialLoad = to.path !== from.path;
    if (isInitialLoad && to.hash) return { el: to.hash };
  },
});

router.beforeEach((to, from, next) => {
  if (appData.master) document.title = appData.master.identifier;
  next();
});

export default router;
